import { Box, Stack } from "@mui/material";
import RequiredFieldMarker from "@entrilia/shared/components/RequiredFieldMarker";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import type { Field } from "../../../api/types/objectTypes";
import FieldIcon from "../../common/domain-icons/FieldIcon";
import FieldEdit from "./FieldEdit";

interface Props {
  field: Field;
  value: unknown;
  onChange: (fieldId: string, value: unknown) => void;
  validationError?: string;
  disabled?: boolean;
  labelWidth?: string | number;
}

const FieldEditRow = ({ field, value, onChange, validationError, disabled, labelWidth = "10rem" }: Props) => (
  <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
    <Stack direction="row" spacing={1} sx={{ alignItems: "center", width: labelWidth, minWidth: labelWidth }}>
      <FieldIcon fieldType={field.type} color="action" fontSize="small" />
      <Box sx={{ display: "flex", alignItems: "center", minWidth: 0 }}>
        <TypographyTooltipEllipsis
          text={field.name}
          typographyProps={{ color: "textSecondary", sx: { minWidth: 0 } }}
        />
        {field.attributes.includes("Required") && <RequiredFieldMarker />}
      </Box>
    </Stack>
    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
      <FieldEdit
        value={value}
        fieldName={field.id}
        fieldType={field.type}
        fieldConfiguration={field.configuration}
        fieldAttributes={field.attributes}
        onChange={onChange}
        validationError={validationError}
        disabled={disabled}
      />
    </Box>
  </Stack>
);

export default FieldEditRow;
